<template>
  <div :class="['stars-rating', `size_${size}`, { interactive }]">
    <star
      :size="size"
      v-for="(star, index) in stars"
      :key="index"
      :active="star"
      :error-mode="errorMode"
      @click.native="onClick(index)"
    />
  </div>
</template>

<script>
import Star from './star.vue';

export default {
  name: 'stars-rating',

  components: { Star },

  props: {
    value: {
      type: Number,
      default: 0,
      validator: function (value) {
        return value >= 0 && value <= 5;
      },
    },
    size: {
      type: String,
      default: '12',
    },
    errorMode: {
      type: Boolean,
      default: false,
    },
    interactive: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    stars() {
      return new Array(5)
        .fill(false)
        .map((i, index) => (index + 1) <= this.value)
    }
  },

  methods: {
    onClick(index) {
      this.$emit('input', index + 1);
    }
  }
}
</script>

<style lang="scss">
  .stars-rating {
    display: flex;
    justify-content: center;
    line-height: normal;

    &.size_56 .star {
      margin-right: 14px;
    }
    &.size_52 .star {
      margin-right: 13px;
    }
    &.size_48 .star {
      margin-right: 12px;
    }
    &.size_42 .star {
      margin-right: 10px;
    }
    &.size_32 .star {
      margin-right: 8px;
    }
     &.size_24 .star {
      margin-right: 6px;
    }
    &.size_12 .star {
      margin-right: 4px;
    }

    .star {
      &:last-child {
        margin-right: 0;
      }
    }

    &.interactive .star__inner {
      cursor: pointer;
    }
  }
</style>